import { LazyModule, LazyImport } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "AnimationStore" */ './lazyIndex')
);
export const lazyGetShouldAnimate = new LazyImport(lazyModule, m => m.getShouldAnimate);

export { mailListItemAnimationStore } from './store/Store';

export { ActionId } from './util/actionId';

export { startAnimatedAction } from './util/startAnimatedAction';

export { clearAnimationActions } from './actions/clearAnimationActions';
